import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import { FullScreen } from "leaflet.fullscreen";

interface Props {
  /**
   * The element to expand. Defaults to the Leaflet container.
   *
   * The trap site editor passes the outer wrapper so that its panel - which is
   * a sibling of the map, not a child - expands with it.
   */
  fullscreenElement?: HTMLElement | null;
}

const MapExpand: React.FC<Props> = ({ fullscreenElement }) => {
  const map = useMap();

  useEffect(() => {
    const newControl = new FullScreen({
      position: "bottomright",
      // Pseudo-fullscreen (a CSS class) rather than the native Fullscreen API.
      // Native fullscreen renders only the fullscreen element's subtree, which
      // would hide anything portalled to document.body - every antd Select,
      // Popconfirm and Dropdown popup, and `message` toasts, which cannot be
      // relocated without a global config change. It also needs a live user
      // gesture, so it cannot be entered after an await, and it swallows
      // Escape. A class toggle has none of those problems.
      forcePseudoFullscreen: true,
      ...(fullscreenElement ? { fullscreenElement } : {}),
    });

    map.addControl(newControl);
    // Removed on unmount; without this a remount stacks duplicate buttons.
    return () => {
      map.removeControl(newControl);
    };
  }, [map, fullscreenElement]);

  return null;
};

export default MapExpand;
